// extracted by mini-css-extract-plugin
module.exports = {"main":"MideaLogo_main__h4L5C","login":"MideaLogo_login__l83UJ"};